import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-diagnosis-link',
    templateUrl: './diagnosis-link.component.html',
    styleUrls: ['./diagnosis-link.component.scss'],
    standalone: false
})
export class DiagnosisLinkComponent {
  @Input() element: any;
  @Output() fileClick = new EventEmitter();

  constructor() {}

  handleFileClick(event, element) {
    event.preventDefault();
    event.stopPropagation();
    console.log('element', element);
    this.fileClick.emit(element);
  }

  toggleDiagnosisContent(diagnosis, event) {
    event.preventDefault();
    event.stopPropagation();
    diagnosis.expanded = !diagnosis.expanded;
  }
}
